export default __webpack_public_path__ + "static/media/White0001.e05de892.png";